import React from "react";

import classnames from "classnames";

import type { JSX } from "react";

interface VideoPreviewProps {
  videoUrl: string;
  badgeLabel?: string;
  isDimmed?: boolean;
}

export default function VideoPreview({
  videoUrl,
  badgeLabel,
  isDimmed,
}: VideoPreviewProps): JSX.Element {
  const containerClassNames = classnames(
    "relative aspect-video w-full overflow-hidden rounded-[0.3125rem]",
    { "border-input border border-dashed": isDimmed },
  );

  return (
    <div className={containerClassNames}>
      <video controls className="size-full" preload="metadata" src={videoUrl}>
        <track kind="captions" />
      </video>
      {badgeLabel ? (
        <span className="bg-card/90 text-foreground absolute top-2.5 right-2.5 rounded-[0.15625rem] px-1.25 py-[0.15625rem] text-[0.78125rem] font-medium">
          {badgeLabel}
        </span>
      ) : null}
    </div>
  );
}
